import type { AbstractControl, ValidationErrors } from '@angular/forms';

export const isBoolean = (control: AbstractControl): ValidationErrors | null => {
  if (control.value === 'true' || control.value === 'false') return null;
  return { 'isBoolean': true };
};
